import Cookie from 'js-cookie';

import { Config } from '@nw/shared/config';
import { isGammaOrProdEnv } from '@nw/shared/utils';

import {
  FALL_BACK,
  getAppCookieDomainToClearTokens,
  getCookie,
  getCookieAttrubutes,
  setCookie
} from '../AccountsStorageUtils';

const PAYMENT_ACCESS_TOKEN_KEY = isGammaOrProdEnv()
  ? 'QzSAqQAdqk'
  : 'NdSAqRgdUs';
const PAYMENT_REFRESH_TOKEN_KEY = isGammaOrProdEnv()
  ? 'MIuSiNUIRj'
  : 'NdSiFZEXl';

export function setPaymentsRefreshTokenToDomain(
  refreshToken: string,
  expiryInDays = 30
) {
  setCookie(PAYMENT_REFRESH_TOKEN_KEY, refreshToken, expiryInDays);
}

export function setPaymentsAccessTokenToDomain(
  accessToken: string,
  expiryInDays = 30
) {
  setCookie(PAYMENT_ACCESS_TOKEN_KEY, accessToken, expiryInDays);
}

export function getPaymentRefreshToken() {
  return getCookie(PAYMENT_REFRESH_TOKEN_KEY);
}
export const isPaymentEnabled = (): boolean => {
  return Config['ENABLE_PAYMENTS'] === '1' ? true : false;
};

export function getPaymentAccessToken(): string {
  return isPaymentEnabled() ? getCookie(PAYMENT_ACCESS_TOKEN_KEY) : '';
}

export const clearPaymentsAccessToken = (domain?: string) => {
  Cookie.remove(PAYMENT_ACCESS_TOKEN_KEY, {
    ...getCookieAttrubutes(),
    domain: domain,
    sameSite: 'None'
  });
  Cookie.remove(`${PAYMENT_ACCESS_TOKEN_KEY}_${FALL_BACK}`, {
    ...getCookieAttrubutes(),
    domain: domain
  });
};

export const clearPaymentsRefreshToken = (domain?: string) => {
  Cookie.remove(PAYMENT_REFRESH_TOKEN_KEY, {
    ...getCookieAttrubutes(),
    domain: domain,
    sameSite: 'None'
  });
  Cookie.remove(`${PAYMENT_REFRESH_TOKEN_KEY}_${FALL_BACK}`, {
    ...getCookieAttrubutes(),
    domain: domain
  });
};

export const clearPaymentsAuthDomainTokens = () => {
  const appCookieDomain = getAppCookieDomainToClearTokens();
  if (appCookieDomain) {
    clearPaymentsAccessToken(appCookieDomain);
    clearPaymentsRefreshToken(appCookieDomain);
  }
};

export const clearAllPaymentsDomainTokens = () => {
  clearPaymentsAuthDomainTokens();
  clearPaymentsAccessToken();
  clearPaymentsRefreshToken();
};
